import { LogSeverity } from '@app/shared/models/local/LogSeverity.enum';

export const environment = {
  production: false,
  umcQATesterRole: 'QualityAssuranceTester',
  testPermissions: true,
  umcApplicationKey: 'DIS',
  environmentName: 'STA',
  apiUrl: 'https://dis-api.sta.montblanc.biz/api/v1/',
  loglevel: LogSeverity.Warning,
  defaultLanguage: 'en-US',
  supportedLanguages: [{ locale: 'en-US', name: 'English' }],
  loginExpiryTime: 5,
  skipHttpErrorInterceptor: [/api\/v1\/files/, /api\/v1\/return-processes\/\d{1,5}\/documents/],
  testerPermissionsRoleProduction: 'TesterPermissionLedge',
  oktaSettings: {
    issuer: 'https://login-dev.montblanc.com/oauth2/aus1vyf0ta9oa9WNp1d8',
    clientId: '0oa1y9ew42cwf4evp1d8',
    scopes: ['access', 'richemont.profile.email', 'openid', 'offline_access'],
    endpoints: ['https://dis-api.sta.montblanc.biz'],
  },
};
